







  import { computed, defineComponent } from 'vue'
  import { CMS } from '@one/types'
  import useCurrentInstance from '~/utils/useCurrentInstance'
  import { createHeaderCmsComponents } from '~/utils/cmsComponents'
  import GridContainer = CMS.Grid.GridContainer

  export default defineComponent({
    components: {
      OneCmsGridRender: () => import('~/components/molecules/renders/OneCmsGridRender.vue'),
    },
    setup() {
      const vm = useCurrentInstance()

      const availableComponents = createHeaderCmsComponents()

      const configuration = computed(() => vm.$store.getters['cms/configuration'])
      const header = computed<GridContainer | undefined>(() => configuration.value?.header)

      return {
        availableComponents,
        header,
      }
    },
  })
